import { httpPost, httpDownload } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../constants/external-constants';
import {
    getInventoryASPU,
    setInventoryASPUError,
    setInventoryASPUColSearchStr,
    sortInventoryASPUItems,
    setInventoryASPUPageSize,
    setInventoryASPUFilter,
    applyInventoryASPUFilter,
    resetInventoryASPUData
} from "../../../constants/model-reducers/external/inventory/circuit-details/aspu.settings";
import { convertToFormatLocalDate } from '../../../utils/helpers.utils';
       
const defaultState = () => ({
    isInventoryASPULoaded: false,
    isInventoryASPUError: false,
    inventoryASPUItems: DEFAULT_TABLE_RESULT_MODEL,
    inventoryASPUColSort: '',
    inventoryASPUIsSortedAsc: true,
    inventoryASPUTableFilterList: [],
    inventoryASPUTableFilterApply: false,
});

const initialState = defaultState();

export const inventoryASPUActions = {
    getInventoryASPU: (pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryASPU.inventoryASPUItems;
        const { inventoryASPUIsSortedAsc, inventoryASPUColSort, inventoryASPUTableFilterList, inventoryASPUTableFilterApply } = state().inventoryASPU;

        var userId = sessionStorage.getItem('UserID');

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: inventoryASPUColSort,
                IsSortAscending: inventoryASPUIsSortedAsc,
                TableFilterList: inventoryASPUTableFilterList,
                ApplyFilter: inventoryASPUTableFilterApply
            };
    
            var inventoryItems = await httpPost('external/inventory/getASPUInventoryItems', data);

            dispatch({
                type: getInventoryASPU,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryASPULoaded: true,
                isInventoryASPUError: false
            });
        }

        catch (e) {
            dispatch({
                type: setInventoryASPUError,
                isInventoryASPUError: true,
                isInventoryASPULoaded: false
            });
        }
    },
    setResetSearch: () => async (dispatch, state) => {
        const { inventoryASPUItems } = state().inventoryASPU;
        var inventoryASPUItemsUpd = {
            ...inventoryASPUItems,
            "Headers": {}
        }

        dispatch({
            type: setInventoryASPUColSearchStr,
            data: inventoryASPUItemsUpd,
            isInventoryASPUError: false,
            isInventoryASPULoaded: false
        });
    },
    setInventoryASPUColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { inventoryASPUItems } = state().inventoryASPU;
        var inventoryASPUItemsUpd = {
            ...inventoryASPUItems,
            "Headers": {
                ...inventoryASPUItems.Headers,
                [key]: {

                    ...inventoryASPUItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInventoryASPUColSearchStr,
            data: inventoryASPUItemsUpd,
            isInventoryASPUError: false,
            isInventoryASPULoaded: true
        });
    },
    sortInventoryASPUItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().inventoryASPU.inventoryASPUItems.Pagination;
        const { inventoryASPUItems, inventoryASPUTableFilterList, inventoryASPUTableFilterApply } = state().inventoryASPU;
        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: inventoryASPUItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...inventoryASPUItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: inventoryASPUTableFilterList,
            ApplyFilter: inventoryASPUTableFilterApply
        };
        var resInventoryASPUItems = await httpPost('external/inventory/getASPUInventoryItems', data);
        if (resInventoryASPUItems.ok === false) {
            dispatch({
                type: setInventoryASPUError,
                isInventoryASPUError: true,
                isInventoryASPULoaded: false
            });
        } else {
            dispatch({
                type: sortInventoryASPUItems,
                inventoryASPUItems: Object.keys(resInventoryASPUItems).length > 0 ? resInventoryASPUItems : DEFAULT_TABLE_RESULT_MODEL,
                inventoryASPUColSort: columnClicked,
                inventoryASPUIsSortedAsc: isSortedAsc,
                isInventoryASPULoaded: true
            });
        }
    },

    resizeInventoryASPUPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setInventoryASPUPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    extractInventoryASPU: () => async (dispatch, state) => {
        const { Headers } = state().inventoryASPU.inventoryASPUItems;
        const { inventoryASPUIsSortedAsc, inventoryASPUColSort, inventoryASPUTableFilterList, inventoryASPUTableFilterApply } = state().inventoryASPU;

        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat } = state().adminSetting;
        var filename = `ATEM ${dealName} ASPU Extract – ${convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-')}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: inventoryASPUColSort,
            IsSortAscending: inventoryASPUIsSortedAsc,
            FileName: filename,
            TableFilterList: inventoryASPUTableFilterList,
            ApplyFilter: inventoryASPUTableFilterApply
        };

        httpDownload('external/inventory/getASPUExtractInventoryItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    addInventoryASPUFilter: (tableFilter) => (dispatch, state) => {
        const { inventoryASPUTableFilterList } = state().inventoryASPU;

        var filterList = [...inventoryASPUTableFilterList, tableFilter];

        dispatch({
            type: setInventoryASPUFilter,
            filterList: filterList
        })
    },

    removeInventoryASPUFilter: (removeIndex) => (dispatch, state) => {
        const { inventoryASPUTableFilterList } = state().inventoryASPU;

        var filterList = inventoryASPUTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setInventoryASPUFilter,
            filterList: filterList
        })
    },

    applyInventoryASPUFilter: (isApply) => (dispatch, state) => {
        const { inventoryASPUTableFilterList } = state().inventoryASPU;

        dispatch({
            type: applyInventoryASPUFilter,
            applyFilter: isApply,
            filterList: isApply ? inventoryASPUTableFilterList : []
        });
    },

    saveInventoryASPUCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryASPU.inventoryASPUItems;
        const { inventoryASPUIsSortedAsc, inventoryASPUColSort, inventoryASPUTableFilterList, inventoryASPUTableFilterApply } = state().inventoryASPU;

        try {
            var userId = sessionStorage.getItem('UserID');

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.ASPUInventoryManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/inventory/saveCustomizeColumns', customizeFormData);

            dispatch({
                type: setInventoryASPUError,
                isInventoryASPUError: true,
                isInventoryASPULoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: inventoryASPUColSort,
                IsSortAscending: inventoryASPUIsSortedAsc,
                TableFilterList: inventoryASPUTableFilterList,
                ApplyFilter: inventoryASPUTableFilterApply
            };

            var inventoryItems = await httpPost('external/inventory/getASPUInventoryItems', data);

            dispatch({
                type: getInventoryASPU,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryASPULoaded: true,
                isInventoryASPUError: false
            });
        }
        catch (e) {
            dispatch({
                type: setInventoryASPUError,
                isInventoryASPUError: true,
                isInventoryASPULoaded: false
            });
        }
    },

    resetInventoryASPUData: () => async (dispatch) => {
        dispatch({ type: resetInventoryASPUData, data: DEFAULT_TABLE_RESULT_MODEL });
    },

};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInventoryASPU:
            return {
                ...state,
                inventoryASPUItems: action.inventoryItems,
                isInventoryASPULoaded: action.isInventoryASPULoaded,
                isInventoryASPUError: action.isInventoryASPUError
            };
        case setInventoryASPUError:
            return {
                ...state,
                isInventoryASPUError: action.isInventoryASPUError,
                isInventoryASPULoaded: action.isInventoryASPULoaded
            }
        case setInventoryASPUColSearchStr:
            return {
                ...state,
                inventoryASPUItems: action.data,
                isInventoryASPULoaded: action.isInventoryASPULoaded,
                isInventoryASPUError: action.isInventoryASPUError
            }
        case sortInventoryASPUItems:
            return {
                ...state,
                inventoryASPUItems: action.inventoryASPUItems,
                inventoryASPUColSort: action.inventoryASPUColSort,
                inventoryASPUIsSortedAsc: action.inventoryASPUIsSortedAsc,
                isInventoryASPULoaded: action.isInventoryASPULoaded
            }
        case setInventoryASPUPageSize:
            return {
                ...state,
                inventoryASPUItems: {
                    ...state.inventoryASPUItems,
                    Pagination: {
                        ...state.inventoryASPUItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setInventoryASPUFilter:
            return {
                ...state,
                inventoryASPUTableFilterList: action.filterList
            }
        case applyInventoryASPUFilter:
            return {
                ...state,
                inventoryASPUTableFilterApply: action.applyFilter,
                inventoryASPUTableFilterList: action.filterList
            }
        case resetInventoryASPUData:
            return {
                ...state,
                inventoryASPUItems: action.data
            };
        default:
            return state;
    }
};